export class ActivityLogModel {
  activityId: number;
  jsonData: string;
  saleId: number;
  horseId: number;
  studyInstanceUID: string;
  seriesInstanceUID: string;
  disclosedClient: string;
  studyFileId: number[];
}

export class ActivityLogResponseModel {
  isNewActivityCreated: boolean;
  isUpdated: boolean;
}

export class Activity {
  static XRayView = 1;
  static ScopeView = 2;
  static ReportView = 3;
  static StudyApproved = 4;
  static StudyDenied = 5;
  static StudyUploadedXray = 6;
  static StudyFileUploaded = 7;
}
